import { lazy } from "react";
import { RouteConfig } from "../../types/RouteConfig";

export const testPageRoute: RouteConfig<'with-page'> = {
    name: 'Testing',
    path: '/test',
    page: lazy(() => import('.')),
    icon: 'mdi mdi-test-tube',
    roles: ['developer'],
}